import * as types from './types';

export const savingOfflineAnnouncements = (data) => ({
  type: types.SAVING_OFFLINE_ANNOUN,
  payload: data,
});

export const savingOfflineDisclosures = (data) => ({
  type: types.SAVING_OFFLINE_DISCLO,
  payload: data,
});

export const resetDataDisclosures = () => ({
  type: types.RESET_DATA_DISCLOSURES,
});
export const resetDataAnnouncements = () => ({
  type: types.RESET_DATA_ANNOUNCEMENTS,
});
